export default __webpack_public_path__ + "static/media/Leg_right.3670bb58.svg";